/**
 * Public site origin for canonical URLs, Open Graph, and JSON-LD.
 * Set `VITE_SITE_ORIGIN` in `.env` (e.g. https://www.avachatai.com). Trailing slash is stripped.
 */
export function getSiteOrigin(): string {
  const raw = import.meta.env.VITE_SITE_ORIGIN?.trim();
  if (raw) return raw.replace(/\/$/, "");
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin.replace(/\/$/, "");
  }
  return "https://www.avachatai.com";
}

export function absoluteUrl(pathOrUrl: string): string {
  if (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://")) {
    return pathOrUrl;
  }
  const origin = getSiteOrigin();
  const p = pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;
  return `${origin}${p}`;
}
